/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamDisciplineSingleQueryResponse,
  GetApiV1ExamDisciplineSingleQueryParams,
  GetApiV1ExamDisciplineSingle400,
  GetApiV1ExamDisciplineSingle401,
  GetApiV1ExamDisciplineSingle500,
} from "../../types/examSharedController/GetApiV1ExamDisciplineSingle.ts";

function getGetApiV1ExamDisciplineSingleUrl() {
  const res = { method: "GET", url: `/api/v1/exam/discipline-single` as const };
  return res;
}

/**
 * @description Retorna disciplinas filtradas pelo texto informado no nome ou código. Quando o id é informado, retorna apenas a disciplina correspondente. Filtra pela empresa quando companyId é fornecido. **(Requer Authorization para autenticação)**
 * @summary Buscar disciplinas por nome (Requer Authorization para autenticação)
 * {@link /api/v1/exam/discipline-single}
 */
export async function getApiV1ExamDisciplineSingle(
  params?: GetApiV1ExamDisciplineSingleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamDisciplineSingleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineSingle400
      | GetApiV1ExamDisciplineSingle401
      | GetApiV1ExamDisciplineSingle500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamDisciplineSingleUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
